import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { ApiService } from "src/core/http/api.service";
import { Observable, of } from "rxjs";
import { map } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class ReportService {
  constructor(private apiService: ApiService, public http: HttpClient) {}

  public GetFacilities(
    startIndex = 0,
    pageSize = 40,
    sorting = "",
    search = "",
    filter: any = null
  ): Observable<any> {
    let searchParams = new HttpParams()
      .set("startIndex", startIndex.toString())
      .set("pageSize", pageSize.toString())
      .set("sorting", sorting)
      .set("search", search);

    if (filter) {
      for (const key of Object.keys(filter)) {
        searchParams = searchParams.set(
          key,
          filter[key] ? filter[key].toString() : null
        );
      }
    }
    return this.apiService.Get("reports/encounter", searchParams);
  }

  public GetFacilitiesExcel(startIndex = 0, pageSize = 40, sorting = "", search = "", filter: any = null): Observable<any> {
    let searchParams = new HttpParams()
      .set("startIndex", startIndex.toString())
      .set("pageSize", pageSize.toString())
      .set("sorting", sorting)
      .set("search", search);

    if (filter) {
      for (const key of Object.keys(filter)) {
        searchParams = searchParams.set(key, filter[key] ? filter[key].toString() : null
        );
      }
    }
    return this.apiService.GetBlob("reports/encounterexcel", searchParams);
  }

  // public getProvidersCompare(monthOfYear: number): Observable<any> {
  //   const searchParams = new HttpParams()
  //   .set('monthOfYear', monthOfYear.toString());

  //   return this.apiService.Get('reports/ProvidersCompare', searchParams);
  // }

  public getProvidersCompare(parameter: any): Observable<any> {
    return this.apiService.Post("reports/ProvidersCompare", parameter);
  }

  public getProviderRVUMetrics(authUserId: number): Observable<any> {
    const searchParams = new HttpParams().set(
      "authUserId",
      authUserId.toString()
    );

    return this.apiService.Get("reports/ProviderRVUMetrics", searchParams);
  }

  public getFacilityCodingIntensity(year: number): Observable<any> {
    const searchParams = new HttpParams().set("year", year.toString());

    return this.apiService.Get("reports/FacilityCodingIntensity", searchParams);
  }

  public getPatientHistoryExcel(search = "", filter: any = null) {
    let searchParams = new HttpParams().set("search", search);

    if (filter) {
      for (const key of Object.keys(filter)) {
        searchParams = searchParams.set(
          key,
          filter[key] ? filter[key].toString() : null
        );
      }
    }
    return this.apiService.GetBlob("reports/PatientHistoryExcel", searchParams);
  }

  public getPatientHistory(
    filter: any = null,
    searchText = ""
  ): Observable<any> {
    let searchParams = new HttpParams().set("searchText", searchText);

    if (filter) {
      for (const key of Object.keys(filter)) {
        searchParams = searchParams.set(
          key,
          filter[key] ? filter[key].toString() : null
        );
      }
    }

    return this.apiService.Get("reports/PatientHistory", searchParams).pipe(
      map((res) => {
        res.Data.map((patientHistory) => {
          patientHistory["FullName"] = {
            FirstName: patientHistory.FirstName
              ? patientHistory.FirstName
              : null,
            LastName: patientHistory.LastName ? patientHistory.LastName : null,
            MiddleName: patientHistory.MiddleName
              ? patientHistory.MiddleName
              : null,
            Suffix: patientHistory.Suffix ? patientHistory.Suffix : null,
          };
          patientHistory["Facility"] = {
            FacilityCode: patientHistory.FacilityCode
              ? patientHistory.FacilityCode
              : null,
            FacilityDesc: patientHistory.FacilityDesc
              ? patientHistory.FacilityDesc
              : null,
          };

          patientHistory[
            "AdminProvider"
          ] = patientHistory.AdminProviderFirstName
            ? patientHistory.AdminProviderFirstName
            : "" + " " + patientHistory.AdminProviderLastName
            ? patientHistory.AdminProviderLastName
            : "";

          patientHistory[
            "DischargeProvider"
          ] = patientHistory.DischargeProviderFirstName
            ? patientHistory.DischargeProviderFirstName
            : "" + " " + patientHistory.DischargeProviderLastName
            ? patientHistory.DischargeProviderLastName
            : "";
        });

        res.Data = {
          Items: res.Data,
          TotalItems: res.Data.length,
        };

        return res;
      })
    );
  }

  public getPotentialDischargeHistory(
    filter: any = null,
    facilityIds = "",
    searchText = ""
  ): Observable<any> {
    let searchParams = new HttpParams()
      .set("searchText", searchText)
      .set("facilityIds", facilityIds);

    if (filter) {
      for (const key of Object.keys(filter)) {
        searchParams = searchParams.set(
          key,
          filter[key] ? filter[key].toString() : null
        );
      }
    }

    return this.apiService
      .Get("reports/PotentialDischargeHistory", searchParams)
      .pipe(
        map((res) => {
          res.Data.map((patientHistory) => {
            patientHistory["FullName"] = {
              FirstName: patientHistory.FirstName
                ? patientHistory.FirstName
                : null,
              LastName: patientHistory.LastName
                ? patientHistory.LastName
                : null,
              MiddleName: patientHistory.MiddleName
                ? patientHistory.MiddleName
                : null,
              Suffix: patientHistory.Suffix ? patientHistory.Suffix : null,
            };
            patientHistory["Facility"] = {
              FacilityCode: patientHistory.FacilityCode
                ? patientHistory.FacilityCode
                : null,
              FacilityDesc: patientHistory.FacilityDesc
                ? patientHistory.FacilityDesc
                : null,
            };
          });
          res.Data = {
            Items: res.Data,
            TotalItems: res.Data.length,
          };
          return res;
        })
      );
  }

  public getPotentialDischargeExcel(
    search = "",
    facilityIds = "",
    filter: any = null
  ) {
    let searchParams = new HttpParams()
      .set("search", search)
      .set("facilityIds", facilityIds);

    if (filter) {
      for (const key of Object.keys(filter)) {
        searchParams = searchParams.set(
          key,
          filter[key] ? filter[key].toString() : null
        );
      }
    }
    return this.apiService.GetBlob(
      "reports/PotentialDischargeHistoryExcel",
      searchParams
    );
  }

  public getAvoidableReasonsReport(
    filter: any = null,
    facilityIds = "",
    searchText = ""
  ): Observable<any> {
    let searchParams = new HttpParams()
      .set("searchText", searchText)
      .set("facilityIds", facilityIds);

    if (filter) {
      for (const key of Object.keys(filter)) {
        searchParams = searchParams.set(
          key,
          filter[key] ? filter[key].toString() : null
        );
      }
    }

    return this.apiService
      .Get("reports/AvoidablePatientHistory", searchParams)
      .pipe(
        map((res) => {
          res.Data.map((pdHistory) => {
            pdHistory["Facility"] = {
              Facility: pdHistory.FacilityCode,
              Room: pdHistory.RoomNum,
            };
          });

          res.Data = {
            Items: res.Data,
            TotalItems: res.Data.length,
          };
          return res;
        })
      );
  }

  public getAvoidableReasonsReportExcel(
    search = "",
    facilityIds = "",
    filter: any = null
  ) {
    let searchParams = new HttpParams()
      .set("search", search)
      .set("facilityIds", facilityIds);

    if (filter) {
      for (const key of Object.keys(filter)) {
        searchParams = searchParams.set(
          key,
          filter[key] ? filter[key].toString() : null
        );
      }
    }
    return this.apiService.GetBlob(
      "reports/AvoidablePatientHistoryExcel",
      searchParams
    );
  }
}
